// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

import graph from 'app/lib/graph';

class RequestOwnership extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    if (this.props.confirmation) {
      return this.setState({ modal: true });
    }
    this.props?.onClick();
  };

  handleConfirmation = async () => {
    const dwelling = this.props.dwelling;

    const res = await graph(
      'mutation  RequestOwnership($id: ID!) { requestOwnership(id: $id) }',
      {
        id: dwelling
      }
    );

    if (res.data?.requestOwnership) {
      this.props?.onSubmit(res.data.requestOwnership);
    }

    this.handleClose();
  };

  renderTriggerButton() {
    const label = this.props.i18n('Anmodning om Ejerforhold');
    const buttonProps = this.props.buttonProps || {};

    return (
      <Button
        tabIndex={-1}
        label={label}
        onClick={this.handleClick}
        {...buttonProps}
      />
    );
  }

  render() {
    const label = this.props.i18n('Anmodning om Ejerforhold');

    if (this.props.confirmation) {
      const actions = this.state.password
        ? [
            <Button
              key="close"
              primary
              autoFocus
              label={this.props.i18n('Close')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />
          ]
        : [
            <Button
              key="cancel"
              secondary
              flat
              label={this.props.i18n('Cancel')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />,
            <Button
              key="submit"
              primary
              autoFocus
              label={this.props.i18n('Confirm')}
              onClick={this.handleConfirmation}
              style={{ marginLeft: '12px' }}
            />
          ];

      return this.state.modal ? (
        <>
          <Dialog
            open
            fullWidth
            fullScreen={this.props.fullScreen}
            onClose={this.handleClose}
            className="dialog-common"
          >
            <DialogTitle>{label}</DialogTitle>
            <DialogContent>
              {this.props.i18n(
                'Bekræft afsendelse af anmodning om ejerforhold til udlejer'
              )}
            </DialogContent>
            <DialogActions>{actions}</DialogActions>
          </Dialog>
          {this.renderTriggerButton()}
        </>
      ) : (
        this.renderTriggerButton()
      );
    }

    return this.renderTriggerButton();
  }
}

const RequestOwnershipI18n = i18n(RequestOwnership);

function RequestOwnershipWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <RequestOwnershipI18n {...props} fullScreen={fullScreen} />;
}

export default RequestOwnershipWithMobileDialog;